import Utils from "../util/utils";
import $scrollTo from 'jquery.scrollto/jquery.scrollTo';

export default {
    init() {
        /*this.scrollDirection = 0; // 0 = scrollDown; 1 = scrollUp
        this.previousScrollPosition = 0;*/
        this.utilities = new Utils();

        // JavaScript to be fired on the single project
        this.initLegend ();
        this.initInfos();
        // this.initSnapScrollGallery ();
    },

    initLegend () {
        const imageItems = document.querySelectorAll('.gallery-item');
        // console.log (imageItems);
        imageItems.forEach( (item) => {
            let link = item.querySelector('.js-legend');
            if ( link ) {
                link.addEventListener ('click', () => {
                    item.classList.toggle('open-legend');
                });
            }
        });
    },

    isTouchDevice () {
        if ("ontouchstart" in document.documentElement) {
            $('body').addClass('touch-device');
            return true;
        } else {
            return false;
        }
    },

    initSnapScrollGallery () {
        const gallery = document.querySelectorAll('.gallery-item');
        const { innerHeight, innerWidth } = window;
        const offsetTop = 200;
        const offsetBottom = 200;
        let scrollAutoEvent = false;
        // let isScrolling
        if ( !this.isTouchDevice () ) {
            window.addEventListener("scroll", () => {
                const direction = this.utilities.getScrollDirection();
                // clearTimeout(isScrolling);
                // isScrolling = setTimeout(() => {
                    console.log ('scrollStop');
                    if (!scrollAutoEvent && ($(window).innerWidth() > 991) && !document.querySelector('body').classList.contains('scroll-to-top')) {
                        // console.log(scrollEvent);
                        gallery.forEach((item) => {
                            // console.log (item);
                            const {top, left, bottom, right} = item.getBoundingClientRect();

                            if (direction === 0) {
                                // console.log (item, top, direction);
                                if (top > 0 && (top < innerHeight - offsetTop)) {
                                    console.log(item, top, direction);
                                    scrollAutoEvent = true;

                                    $scrollTo(
                                        $(item),
                                        400,
                                        {
                                            onAfter: () => {
                                                scrollAutoEvent = false;
                                            }
                                        }
                                    )
                                }
                            } else {
                                if (bottom > 0 && bottom < innerHeight - offsetBottom) {
                                    // console.log(item, bottom);
                                    scrollAutoEvent = true;

                                    $scrollTo(
                                        $(item),
                                        400,
                                        {
                                            onAfter: () => {
                                                scrollAutoEvent = false;
                                            }
                                        }
                                    )
                                }
                            }
                        });
                    }
                // }, 20);
            }, false);
        }
    },

    initInfos () {
        const infoItems = document.querySelectorAll('.wp-block-column h6');
        // console.log (imageItems);
        infoItems.forEach( (item) => {
            /*let link = item.querySelector('h6');
            if ( link ) {
                link.addEventListener ('click', () => {
                    link.classList.toggle('open-info');
                });
            }*/
            if ( item ) {
                item.addEventListener ('click', () => {
                    item.classList.toggle('open-info');
                });
            }
        });
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        document.querySelector('body').classList.add('loaded');
    },
};
